<template>
  <div :class="`glide-${componentId}`" class="glide">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides">
        <slot />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import Glide from '@glidejs/glide'
import { onMounted, ref } from 'vue'

interface Props {
  type?: 'slider' | 'carousel'
  perView?: number
  startAt?: number
  gap?: number
  breakpoints?: Record<number, Record<string, any>>
}

const options = withDefaults(defineProps<Props>(), {
  type: 'slider',
  perView: 1,
  startAt: 0,
  gap: 10,
  breakpoints: () => ({}),
})

const baseOptions = {
  keyboard: true,
}

// prettier-ignore
const emit = defineEmits(['glide:autoplay', 'glide:build-after', 'glide:build-before', 'glide:mount-after', 'glide:mount-before', 'glide:move-after', 'glide:move', 'glide:pause', 'glide:play', 'glide:resize', 'glide:run-after', 'glide:run-before', 'glide:run-end', 'glide:run-offset', 'glide:run-start', 'glide:run', 'glide:swipe-end', 'glide:swipe-move', 'glide:swipe-start', 'glide:translate-jump', 'glide:update'])
// prettier-ignore
const events = ['autoplay', 'build.after', 'build.before', 'mount.after', 'mount.before', 'move.after', 'move', 'pause', 'play', 'resize', 'run.after', 'run.before', 'run.end', 'run.offset', 'run.start', 'run', 'swipe.end', 'swipe.move', 'swipe.start', 'translate.jump', 'update']

const componentId = useId()
const glide = ref<Glide | null>(null)
const model = defineModel() // eslint-disable-line vue/require-prop-types

function bindEvents(glideInstance: Glide) {
  events.forEach((event) => {
    glideInstance.on(event, (e) => {
      emit('glide:' + event.replace(/\./g, '-'), e)
    })
  })
  glideInstance.on('move', () => {
    model.value = glideInstance.index
  })
}

onMounted(() => {
  const glide_ = new Glide(`.glide-${componentId}`, Object.assign({}, unref(options), baseOptions))
  glide.value = glide_
  bindEvents(glide_)
  glide_.mount()
})

defineExpose({ glide })
</script>

<style scoped lang="scss">
@import '@glidejs/glide/dist/css/glide.core.min.css';
</style>
